<template>
  <div class="flex flex-col items-start gap-3 self-stretch">
    <ProductPreview
      v-if="store.payment?.paymentType === 'product'"
      @open-settings="emit('open-settings')"
    ></ProductPreview>
    <BumpPreview
      v-if="store.payment?.paymentType === 'product' && store.payment.bumpSettings.enableBump"
    ></BumpPreview>
    <div class="flex flex-col items-start gap-3 self-stretch">
      <DonationPreview
        v-if="store.payment.paymentType !== 'product'"
        :payment="payment"
        :input-class="inputClass"
      ></DonationPreview>
      <CouponPreview
        v-if="store.payment.paymentType === 'product' && store.payment?.coupon?.enableCoupon"
      ></CouponPreview>
      <UIAlert
        v-if="store.payment.showInfoAboutPayment"
        id="warning-message"
        type="default"
        :closable="false"
      >
        <template #content>{{ t("common.paymentWillBeProcessed") }}</template>
      </UIAlert>
      <PaymentCardPreview></PaymentCardPreview>
    </div>
    <div v-if="!store.payment.footer.hidden" class="self-stretch text-center text-xs text-gray-400">
      <div
        ref="footerMessageElement"
        :key="resetKey"
        contenteditable="true"
        class="text-border-color-style w-full cursor-text border-0 text-center font-sans text-xs font-normal not-italic leading-[17px] tracking-normal outline-none focus:outline-none"
        @blur="store.addToHistory"
        @input="handleInputFooterMessage"
        @compositionstart="handleCompositionStart"
        @compositionend="compositionEndHandler"
        @keydown="handleSafariCursor"
        @click="(e) => e.stopPropagation()"
        @focus="(e) => e.stopPropagation()"
        v-text="t(store.payment.footer.message)"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useIMEComposition } from "@/composition/useIMEComposition";
import { useAppStore } from "@/store/app";
import { fixSafariCursor } from "@/util/methods";
import { UIAlert } from "@gohighlevel/ghl-ui";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import DonationPreview from "../Donation/DonationPreview.vue";
import BumpPreview from "../Products/bump/bumpPreview.vue";
import ProductPreview from "../Products/ProductPreview.vue";
import CouponPreview from "./CouponPreview.vue";
import PaymentCardPreview from "./PaymentCardPreview.vue";
const { t } = useI18n();
const store = useAppStore();
const footerMessageElement = ref<HTMLElement | null>(null);
const { handleCompositionStart, handleCompositionEnd, withIMECheck, resetKey } =
  useIMEComposition();

const emit = defineEmits(["open-settings"]);

defineProps({
  payment: {
    type: Object,
    default: () => {
      return {};
    },
  },
  inputClass: {
    type: Array,
    default: () => {
      return [];
    },
  },
});

const rawInputFooterMessageHandler = (e: Event) => {
  store.payment.footer.message = (e.target as HTMLElement).textContent;
  handleSafariCursor(e);
};
const compositionEndHandler = handleCompositionEnd(rawInputFooterMessageHandler);
const handleInputFooterMessage = withIMECheck(rawInputFooterMessageHandler);
const handleSafariCursor = (e: Event) => {
  const isKeyDown = e.type === "keydown";
  fixSafariCursor(e, isKeyDown);
};
</script>
